
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/passive-get-explanation';
const mainimage = '/Images/passive1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "passiveget" },
];


const PassiveGet = () => (
  <GrammarPageLayout
    level="B2"
    title="Passive with Get"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Passive with Get Exercises"
    seoDescription="Use get instead of be to form the passive in everyday English, for accidents, changes and unexpected events. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default PassiveGet;
